import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Calendar} from "primereact/calendar";
import {Button} from "primereact/button";
import {InputMask} from "primereact/inputmask";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";

import moment from "moment/moment";
import {InputNumber} from "primereact/inputnumber";

const MilestoneFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    project: id,
    issue_date: new Date(),
  });

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((id && entity === 'milestone') || (window.App.urlVars().update === 'milestone' && window.App.urlVars().milestoneId)) {
      apiCall('patch', "/api/v2/milestone/" + (window.App.urlVars().milestoneId ?? id), data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderMilestoneList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/project/milestone/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/milestone', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderMilestoneList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/project/milestone/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if (window.App.urlVars().partnerName) {
      setFormData({
        ...formData,
        partnerName: decodeURIComponent(window.App.urlVars().partnerName),
        partner: window.App.urlVars().partnerId
      })
    }
  }, [window.App.urlVars().partnerName])

  useEffect(() => {
    if ((entity === 'milestone' && id) || (window.App.urlVars().milestoneId)) {
      setLoading(true);
      axios.get(process.env.REACT_APP_API_HOST + "/api/v2/milestone/" + (window.App.urlVars().milestoneId ?? id),
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"milestone-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="issue_date" render={({input, meta}) => (
                <span className="p-field p-fluid">
                    <label htmlFor="issue_date"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('deadline')}</label>
                    <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"issue_date"}
                                       mask={"9999-99-99"}
                                       placeholder={t('datePlaceholder')}
                                       value={moment.utc(formData.issue_date).local().format('YYYY-MM-DD')}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             issue_date: new Date(e.value)
                                           })
                                         }
                                       }}
                            />
                            <Calendar value={formData.issue_date}
                                      locale="hu"
                                      dateFormat={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          issue_date: e.value
                                        })
                                      }}/>
                    </div>
                  {getFormErrorMessage(meta)}
                  </span>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="income_plan" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="income_plan"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldIncomePlan')}</label>
                  <span className="p-d-block">
                      <InputNumber id="income_plan" {...input}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       income_plan: e.value
                                     })
                                   }}
                                   value={formData.income_plan}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="cost_salary_plan" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="cost_salary_plan"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCostSalaryPlan')}</label>
                  <span className="p-d-block">
                      <InputNumber id="cost_salary_plan" {...input}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       cost_salary_plan: e.value
                                     })
                                   }}
                                   value={formData.cost_salary_plan}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="cost_material_plan" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="cost_material_plan"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCostMaterialPlan')}</label>
                  <span className="p-d-block">
                      <InputNumber id="cost_material_plan" {...input}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       cost_material_plan: e.value
                                     })
                                   }}
                                   value={formData.cost_material_plan}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="cost_other_plan" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="cost_other_plan"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCostOtherPlan')}</label>
                  <span className="p-d-block">
                      <InputNumber id="cost_other_plan" {...input}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       cost_other_plan: e.value
                                     })
                                   }}
                                   value={formData.cost_other_plan}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>

          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'milestone' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(MilestoneFormComponent);
